import type { GlossaryTerm } from './glossary';

/**
 * Phase 3.4a M4 · Block 2 glossary terms (S07 + S08).
 * Auto-converted from writer-slot markdown via
 * `scripts/convert-block2-glossary.mjs`. Per ASK-3.4-4=A · these land
 * directly in the main GLOSSARY array. Slot J «master collation» refines
 * via additive edits later.
 *
 * Source: 02_CONTENT/sprint_07_content.md (~25 entries) +
 *         02_CONTENT/sprint_08_content.md (~25 entries) =
 *         93 terms total.
 */

export const BLOCK_2_TERMS: ReadonlyArray<GlossaryTerm> = [
  {
    "id": "atelier-qa-studio",
    "termRu": "Atelier (QA Studio)",
    "termEn": "Atelier (QA Studio)",
    "short": "Учебная sandbox QA Studio с deterministic broken UI scenarios для bug-hunt practice. W2.1 fixtures для Block 2",
    "istqb": "CTFL-Ch5",
    "introducedIn": "S07"
  },
  {
    "id": "bug-lifecycle",
    "termRu": "жизненный цикл бага",
    "termEn": "Bug Lifecycle",
    "short": "Последовательность состояний bug от нахождения до закрытия: NEW → OPEN → IN_PROGRESS → RESOLVED → VERIFIED → CLOSED + 5 edge states",
    "istqb": "CTFL-Ch5",
    "introducedIn": "S07"
  },
  {
    "id": "build-version",
    "termRu": "сборка / версия приложения",
    "termEn": "Build (version)",
    "short": "Конкретная версия app, на которой найден bug. Например 2026.4.18 или commit hash. Critical для regression analysis",
    "istqb": "CTFL-Ch5",
    "introducedIn": "S07"
  },
  {
    "id": "business-impact",
    "termRu": "бизнес-влияние",
    "termEn": "Business Impact",
    "short": "Что теряет бизнес из-за bug: % users · revenue · brand image · compliance risk. Помогает PM калибровать Priority",
    "istqb": "CTFL-Ch5",
    "introducedIn": "S07"
  },
  {
    "id": "cannot-reproduce",
    "termRu": "не воспроизводится",
    "termEn": "CANNOT_REPRODUCE",
    "short": "Edge state в bug lifecycle: Dev попробовал repro и не смог. Возвращает в QA с request «add more context»",
    "istqb": "CTFL-Ch5",
    "introducedIn": "S07"
  },
  {
    "id": "cross-feature-impact",
    "termRu": "кросс-функциональное влияние",
    "termEn": "Cross-feature impact",
    "short": "Где bug может проявиться помимо primary location (similar handlers, shared code, related features). Senior bug report addition",
    "istqb": "CTFL-Ch5",
    "introducedIn": "S07"
  },
  {
    "id": "deferred",
    "termRu": "отложен",
    "termEn": "DEFERRED",
    "short": "Edge state: bug подтверждён, fix откладывается на following release / quarter (low priority + high effort combination)",
    "istqb": "CTFL-Ch5",
    "introducedIn": "S07"
  },
  {
    "id": "duplicate",
    "termRu": "дубликат",
    "termEn": "DUPLICATE",
    "short": "Edge state: bug уже зарегистрирован под другим ID. Закрывается с link на original. Не редкость в больших командах",
    "istqb": "CTFL-Ch5",
    "introducedIn": "S07"
  },
  {
    "id": "environment",
    "termRu": "окружение / env",
    "termEn": "Environment",
    "short": "Где bug найден: dev / staging / prod · OS · browser · viewport · network · user role. Без specifics — Dev не знает где repro",
    "istqb": "CTFL-Ch5",
    "introducedIn": "S07"
  },
  {
    "id": "evidence-bug-report",
    "termRu": "доказательства / приложения",
    "termEn": "Evidence (bug report)",
    "short": "Файлы прикреплённые к bug report (screenshots · video · DevTools console · Network HAR · server logs). Без = просьба, с = инженерная коммуникация",
    "istqb": "CTFL-Ch5",
    "introducedIn": "S07"
  },
  {
    "id": "frequency",
    "termRu": "частота воспроизведения",
    "termEn": "Frequency",
    "short": "Always / Sometimes (X из Y) / Rarely (1-of-N) / Once. Critical для Dev'ского repro setup. Конкретные числа лучше «иногда»",
    "istqb": "CTFL-Ch5",
    "introducedIn": "S07"
  },
  {
    "id": "heuristic-testing",
    "termRu": "эвристика тестирования",
    "termEn": "Heuristic (testing)",
    "short": "Thinking aid / lens для test design или bug analysis. Не process step. Применяется на complex / cross-feature bugs. SFDIPOT, FEW-HICCUPPS — examples",
    "istqb": "CTFL-Ch5",
    "introducedIn": "S07"
  },
  {
    "id": "linear",
    "termRu": "Linear · linear.app",
    "termEn": "Linear",
    "short": "Modern issue tracker. Used by product teams. Streamlined UX, simpler than Jira but less customizable. Free tier для small teams. Issue model",
    "istqb": "CTFL-Ch5",
    "introducedIn": "S07"
  },
  {
    "id": "linked-issue",
    "termRu": "связанная задача",
    "termEn": "Linked issue",
    "short": "Связь между issues в tracker'е: Blocks / Blocked-by · Related · Duplicate-of · Parent/Sub-issue (epic)",
    "istqb": "CTFL-Ch5",
    "introducedIn": "S07"
  },
  {
    "id": "not-a-bug",
    "termRu": "не баг",
    "termEn": "NOT_A_BUG",
    "short": "Edge state: то что QA зарегистрировал как bug — это expected behavior / feature / PM's design decision. Закрывается с PM explanation",
    "istqb": "CTFL-Ch5",
    "introducedIn": "S07"
  },
  {
    "id": "pre-conditions-bug-report",
    "termRu": "предусловия",
    "termEn": "Pre-conditions (bug report)",
    "short": "Состояние которое должно быть истинным <em>до</em> запуска Steps to Reproduce. State, не actions. Отделяются от Steps",
    "istqb": "CTFL-Ch5",
    "introducedIn": "S07"
  },
  {
    "id": "reopened",
    "termRu": "повторно открыт",
    "termEn": "REOPENED",
    "short": "Edge state: bug был CLOSED, но нашли снова (regression). Возвращается в OPEN с extra context. >2 reopen — root cause analysis обязателен",
    "istqb": "CTFL-Ch5",
    "introducedIn": "S07"
  },
  {
    "id": "reproducibility",
    "termRu": "воспроизводимость",
    "termEn": "Reproducibility",
    "short": "Качество steps to reproduce + frequency. Atomic / verifiable / contextual steps + Always/Sometimes/Rarely calibration",
    "istqb": "CTFL-Ch5",
    "introducedIn": "S07"
  },
  {
    "id": "root-cause-hypothesis",
    "termRu": "гипотеза о причине",
    "termEn": "Root cause hypothesis",
    "short": "Senior bug report addition: гипотеза о причине bug, как starting point для Dev'ской расследование. To verify with Dev",
    "istqb": "CTFL-Ch5",
    "introducedIn": "S07"
  },
  {
    "id": "sfdipot",
    "termRu": "SFDIPOT · heuristic by James Bach",
    "termEn": "SFDIPOT",
    "short": "Test coverage exploration tool: Structure / Function / Data / Interface / Platform / Operations / Time. 7 lens для system thinking. Senior tool, требует teach-block",
    "istqb": "CTFL-Ch5",
    "introducedIn": "S07"
  },
  {
    "id": "sla-service-level-agreement",
    "termRu": "соглашение об уровне обслуживания",
    "termEn": "SLA (Service Level Agreement)",
    "short": "Соглашение о времени реакции / fix per Priority. P0 — 24h · P1 — 1 sprint · etc. Формализует commitment команды",
    "istqb": "CTFL-Ch5",
    "introducedIn": "S07"
  },
  {
    "id": "steps-to-reproduce-str",
    "termRu": "шаги воспроизведения",
    "termEn": "Steps to Reproduce (STR)",
    "short": "Точная последовательность actions, ведущая к bug. Сердце bug report. Atomic / verifiable / contextual",
    "istqb": "CTFL-Ch5",
    "introducedIn": "S07"
  },
  {
    "id": "tracker-issue-tracker",
    "termRu": "трекер задач",
    "termEn": "Tracker (Issue tracker)",
    "short": "Инструмент для регистрации, отслеживания, и закрытия bugs / tasks. Database для defect history. Examples: Linear · Jira · Asana · GitHub Issues",
    "istqb": "CTFL-Ch5",
    "introducedIn": "S07"
  },
  {
    "id": "triage",
    "termRu": "триаж",
    "termEn": "Triage",
    "short": "Процесс командной оценки нового bug: подтверждение что bug, calibration Severity / Priority, assignment Dev'а, установка SLA. На triage meeting",
    "istqb": "CTFL-Ch5",
    "introducedIn": "S07"
  },
  {
    "id": "triage-meeting",
    "termRu": "триаж-встреча",
    "termEn": "Triage meeting",
    "short": "Регулярная встреча команды (daily standup / weekly sync) для review новых bugs. 15-30 min",
    "istqb": "CTFL-Ch5",
    "introducedIn": "S07"
  },
  {
    "id": "aggregate-function",
    "termRu": "агрегатная функция",
    "termEn": "Aggregate Function",
    "short": "Функция, превращающая несколько строк в одно значение: COUNT, SUM, AVG, MIN, MAX. Считает по всему результату или по группам",
    "istqb": "CTFL-Ch4",
    "introducedIn": "S08"
  },
  {
    "id": "alias",
    "termRu": "алиас, псевдоним",
    "termEn": "Alias",
    "short": "Короткое имя таблицы или колонки в query (после AS или просто пробелом). Делает query короче и читаемее: `users u`, `orders o`",
    "istqb": "CTFL-Ch4",
    "introducedIn": "S08"
  },
  {
    "id": "begin-commit-rollback",
    "termRu": "начало / подтверждение / откат транзакции",
    "termEn": "BEGIN / COMMIT / ROLLBACK",
    "short": "TCL-команды для управления транзакциями. BEGIN открывает транзакцию, COMMIT подтверждает изменения, ROLLBACK откатывает",
    "istqb": "CTFL-Ch4",
    "introducedIn": "S08"
  },
  {
    "id": "cell",
    "termRu": "ячейка таблицы",
    "termEn": "Cell",
    "short": "Одно значение на пересечении строки и колонки. Может быть NULL (пустое значение)",
    "istqb": "CTFL-Ch4",
    "introducedIn": "S08"
  },
  {
    "id": "column",
    "termRu": "колонка / столбец таблицы",
    "termEn": "Column",
    "short": "Поле таблицы с именем и типом данных. У users могут быть колонки id, email, created_at",
    "istqb": "CTFL-Ch4",
    "introducedIn": "S08"
  },
  {
    "id": "cte-common-table-expression",
    "termRu": "общее табличное выражение",
    "termEn": "CTE (Common Table Expression)",
    "short": "Именованный временный результат внутри query (`WITH name AS (...) SELECT ...`). **Forward-hook S11 deep**, в S08 не разбираем",
    "istqb": "CTFL-Ch4",
    "introducedIn": "S08"
  },
  {
    "id": "dcl-data-control-language",
    "termRu": "язык управления доступом",
    "termEn": "DCL (Data Control Language)",
    "short": "Команды управления правами доступа: GRANT, REVOKE. Кто к каким таблицам имеет доступ",
    "istqb": "CTFL-Ch4",
    "introducedIn": "S08"
  },
  {
    "id": "ddl-data-definition-language",
    "termRu": "язык описания данных",
    "termEn": "DDL (Data Definition Language)",
    "short": "Команды описания структуры БД: CREATE, ALTER, DROP. Меняют схему — таблицы, колонки, индексы",
    "istqb": "CTFL-Ch4",
    "introducedIn": "S08"
  },
  {
    "id": "delete",
    "termRu": "удаление",
    "termEn": "DELETE",
    "short": "DML-команда удаления строк. Опаснее UPDATE — без WHERE удалит все строки таблицы. Всегда заворачиваем в BEGIN/ROLLBACK",
    "istqb": "CTFL-Ch4",
    "introducedIn": "S08"
  },
  {
    "id": "distinct",
    "termRu": "уникальные значения",
    "termEn": "DISTINCT",
    "short": "Клауза SELECT, которая убирает дубликаты из результата. `SELECT DISTINCT status FROM orders` вернёт уникальные значения колонки",
    "istqb": "CTFL-Ch4",
    "introducedIn": "S08"
  },
  {
    "id": "dml-data-manipulation-language",
    "termRu": "язык манипуляции данными",
    "termEn": "DML (Data Manipulation Language)",
    "short": "Команды изменения данных: INSERT, UPDATE, DELETE. Меняют содержимое таблиц, не структуру",
    "istqb": "CTFL-Ch4",
    "introducedIn": "S08"
  },
  {
    "id": "dql-data-query-language",
    "termRu": "язык запросов",
    "termEn": "DQL (Data Query Language)",
    "short": "Команды чтения данных. По сути одна — SELECT. Самая частая в работе QA",
    "istqb": "CTFL-Ch4",
    "introducedIn": "S08"
  },
  {
    "id": "evidence-query",
    "termRu": "подтверждающий запрос",
    "termEn": "Evidence Query",
    "short": "SQL-query, прикреплённая к bug report как доказательство нахождения. Превращает «у меня странность» в «вот данные, вот аномалия»",
    "istqb": "CTFL-Ch4",
    "introducedIn": "S08"
  },
  {
    "id": "foreign-key-fk",
    "termRu": "внешний ключ",
    "termEn": "Foreign Key (FK)",
    "short": "Колонка в одной таблице, ссылающаяся на primary key другой. orders.user_id ссылается на users.id",
    "istqb": "CTFL-Ch4",
    "introducedIn": "S08"
  },
  {
    "id": "group-by",
    "termRu": "группировка",
    "termEn": "GROUP BY",
    "short": "Клауза SQL, разбивающая строки на группы по значению колонки. Aggregate function применяется к каждой группе отдельно",
    "istqb": "CTFL-Ch4",
    "introducedIn": "S08"
  },
  {
    "id": "having",
    "termRu": "фильтр после агрегации",
    "termEn": "HAVING",
    "short": "Клауза для фильтрации **групп** после GROUP BY. В отличие от WHERE (фильтр строк до агрегации). `HAVING COUNT(*) > 5` — найти группы с количеством больше 5",
    "istqb": "CTFL-Ch4",
    "introducedIn": "S08"
  },
  {
    "id": "index",
    "termRu": "индекс БД",
    "termEn": "Index",
    "short": "Структура данных в БД, ускоряющая поиск по колонке. Аналогия — алфавитный указатель в книге. **Awareness only в S08**, deep — DBA-задача",
    "istqb": "CTFL-Ch4",
    "introducedIn": "S08"
  },
  {
    "id": "inner-join",
    "termRu": "внутреннее соединение",
    "termEn": "INNER JOIN",
    "short": "JOIN, возвращающий только строки с совпадениями в обеих таблицах. Если у пользователя нет orders — он не в результате INNER JOIN",
    "istqb": "CTFL-Ch4",
    "introducedIn": "S08"
  },
  {
    "id": "insert",
    "termRu": "вставка",
    "termEn": "INSERT",
    "short": "DML-команда добавления новых строк в таблицу. Может вставлять одну строку, несколько строк, или результат SELECT",
    "istqb": "CTFL-Ch4",
    "introducedIn": "S08"
  },
  {
    "id": "is-null-is-not-null",
    "termRu": "проверка на NULL",
    "termEn": "IS NULL / IS NOT NULL",
    "short": "Специальные операторы для проверки NULL-значений. Используются вместо `= NULL` (которое всегда даёт UNKNOWN)",
    "istqb": "CTFL-Ch4",
    "introducedIn": "S08"
  },
  {
    "id": "join",
    "termRu": "соединение таблиц",
    "termEn": "JOIN",
    "short": "SQL-операция, объединяющая строки двух таблиц по общему полю. Базовые типы в S08: INNER (только совпадения) и LEFT (все слева + совпадения справа)",
    "istqb": "CTFL-Ch4",
    "introducedIn": "S08"
  },
  {
    "id": "left-join",
    "termRu": "левое соединение",
    "termEn": "LEFT JOIN",
    "short": "JOIN, возвращающий все строки из левой таблицы + совпадения из правой. Где совпадения нет — справа NULL. Полезно для поиска «X без Y» через `WHERE right.id IS NULL`",
    "istqb": "CTFL-Ch4",
    "introducedIn": "S08"
  },
  {
    "id": "like",
    "termRu": "шаблонное сравнение",
    "termEn": "LIKE",
    "short": "Оператор для текстовых паттернов. `%` — любая последовательность, `_` — один символ. `LIKE 'qa-%'` — всё, что начинается с 'qa-'",
    "istqb": "CTFL-Ch4",
    "introducedIn": "S08"
  },
  {
    "id": "limit",
    "termRu": "ограничение количества строк",
    "termEn": "LIMIT",
    "short": "Клауза, ограничивающая количество строк в результате. Базовая безопасность — `LIMIT 10` при первом запросе к незнакомой таблице",
    "istqb": "CTFL-Ch4",
    "introducedIn": "S08"
  },
  {
    "id": "null",
    "termRu": "отсутствие значения",
    "termEn": "NULL",
    "short": "В SQL означает «значения нет». Не пустая строка и не 0. Сравнение через `=` всегда даёт UNKNOWN. Используй IS NULL / IS NOT NULL",
    "istqb": "CTFL-Ch4",
    "introducedIn": "S08"
  },
  {
    "id": "on-clause",
    "termRu": "условие соединения JOIN",
    "termEn": "ON Clause",
    "short": "Условие, по которому соединяются строки двух таблиц. `ON u.id = o.user_id`. Применяется во время JOIN, не после (отличается от WHERE для LEFT JOIN)",
    "istqb": "CTFL-Ch4",
    "introducedIn": "S08"
  },
  {
    "id": "operator-sql",
    "termRu": "оператор сравнения / логический",
    "termEn": "Operator (SQL)",
    "short": "Знак или ключевое слово для сравнения значений. Возвращает TRUE/FALSE/NULL. Сравнение: `=`, `!=`, `<`, `>`. Логические: AND, OR, NOT. Специальные: IN, BETWEEN, LIKE",
    "istqb": "CTFL-Ch4",
    "introducedIn": "S08"
  },
  {
    "id": "order-by",
    "termRu": "сортировка результата",
    "termEn": "ORDER BY",
    "short": "Клауза для упорядочивания строк результата. ASC (ascending, по возрастанию · default) или DESC (descending). Можно по нескольким колонкам",
    "istqb": "CTFL-Ch4",
    "introducedIn": "S08"
  },
  {
    "id": "primary-key-pk",
    "termRu": "первичный ключ",
    "termEn": "Primary Key (PK)",
    "short": "Колонка (часто id), уникально идентифицирующая каждую строку таблицы. Не может быть NULL. Foreign keys ссылаются на primary keys других таблиц",
    "istqb": "CTFL-Ch4",
    "introducedIn": "S08"
  },
  {
    "id": "query",
    "termRu": "запрос",
    "termEn": "Query",
    "short": "Команда к БД на чтение или изменение данных, написанная на SQL. SELECT — самый частый query у QA",
    "istqb": "CTFL-Ch4",
    "introducedIn": "S08"
  },
  {
    "id": "row",
    "termRu": "строка / запись таблицы",
    "termEn": "Row",
    "short": "Одна запись в таблице — конкретный объект. Один row в users = один пользователь. Состоит из значений по всем колонкам таблицы",
    "istqb": "CTFL-Ch4",
    "introducedIn": "S08"
  },
  {
    "id": "select",
    "termRu": "запрос на чтение",
    "termEn": "SELECT",
    "short": "Главная DQL-команда. Возвращает строки таблицы, удовлетворяющие условиям. 90% запросов QA пишет вокруг SELECT",
    "istqb": "CTFL-Ch4",
    "introducedIn": "S08"
  },
  {
    "id": "source-of-truth",
    "termRu": "источник правды (для данных)",
    "termEn": "Source of Truth",
    "short": "Где живут «настоящие» данные системы. Для QA это часто база данных, не UI. UI может задерживать, кэшировать или фильтровать. K2. Sprint 08 (T01) + cross-reference S02 (T01 Tech Spec как source of truth для интеграционных тестов)",
    "istqb": "CTFL-Ch4",
    "introducedIn": "S08"
  },
  {
    "id": "sql-structured-query-language",
    "termRu": "структурированный язык запросов",
    "termEn": "SQL (Structured Query Language)",
    "short": "Стандартный язык для работы с реляционными БД. Произносится «эс-ку-эль» или «сиквел»",
    "istqb": "CTFL-Ch4",
    "introducedIn": "S08"
  },
  {
    "id": "sql-injection",
    "termRu": "SQL-инъекция",
    "termEn": "SQL Injection",
    "short": "Класс уязвимостей, когда атакующий встраивает SQL-команды в input приложения. Защита — prepared statements. **Awareness only в S08**, deep в S12 (Security). K1. Sprint 08 (T05 senior-extension), Sprint 12 (deep)",
    "istqb": "CTFL-Ch4",
    "introducedIn": "S08"
  },
  {
    "id": "sql-investigation-flow",
    "termRu": "SQL-расследование",
    "termEn": "SQL Investigation Flow",
    "short": "5-шаговый процесс QA: гипотеза → query → результат → подтверждение / опровержение → bug report или close",
    "istqb": "CTFL-Ch4",
    "introducedIn": "S08"
  },
  {
    "id": "subquery",
    "termRu": "вложенный запрос",
    "termEn": "Subquery",
    "short": "SELECT внутри другого query (в WHERE/FROM/SELECT). **Forward-hook S11 deep**, в S08 не разбираем",
    "istqb": "CTFL-Ch4",
    "introducedIn": "S08"
  },
  {
    "id": "table",
    "termRu": "таблица БД",
    "termEn": "Table",
    "short": "Контейнер данных в реляционной БД: набор строк (rows), каждая строка — набор колонок (columns). Похоже на лист Excel, но со строгой схемой",
    "istqb": "CTFL-Ch4",
    "introducedIn": "S08"
  },
  {
    "id": "tcl-transaction-control-language",
    "termRu": "язык управления транзакциями",
    "termEn": "TCL (Transaction Control Language)",
    "short": "Команды группирования изменений в транзакции: BEGIN, COMMIT, ROLLBACK, SAVEPOINT. Safety net для опасных DML-операций",
    "istqb": "CTFL-Ch4",
    "introducedIn": "S08"
  },
  {
    "id": "transaction",
    "termRu": "транзакция БД",
    "termEn": "Transaction",
    "short": "Группа изменений, применяемых атомарно (всё или ничего). До COMMIT изменения видны только в твоей сессии. ROLLBACK откатывает к началу",
    "istqb": "CTFL-Ch4",
    "introducedIn": "S08"
  },
  {
    "id": "update",
    "termRu": "обновление",
    "termEn": "UPDATE",
    "short": "DML-команда изменения существующих строк. **ВСЕГДА требует WHERE** — без неё обновит все строки таблицы",
    "istqb": "CTFL-Ch4",
    "introducedIn": "S08"
  },
  {
    "id": "where-clause",
    "termRu": "условие отбора строк",
    "termEn": "WHERE Clause",
    "short": "Клауза для фильтрации строк до агрегации. Условие должно вернуть TRUE для попадания строки в результат. NULL даёт UNKNOWN, тоже не пускает",
    "istqb": "CTFL-Ch4",
    "introducedIn": "S08"
  },
  {
    "id": "api-application-programming-interface",
    "termRu": "интерфейс программирования приложений",
    "termEn": "API (Application Programming Interface)",
    "short": "Набор endpoint'ов и контрактов, через которые приложения общаются. В web-context обычно REST API через HTTP",
    "istqb": "CTFL-Ch4",
    "introducedIn": "S09"
  },
  {
    "id": "api-sql-verification",
    "termRu": "сверка после API call",
    "termEn": "API → SQL verification",
    "short": "Mandatory шаг для critical flow (payments · orders · кэшбек · auth · admin): после API call проверить actual state в БД через SQL",
    "istqb": "CTFL-Ch4",
    "introducedIn": "S09"
  },
  {
    "id": "api-key",
    "termRu": "API-ключ",
    "termEn": "API key",
    "short": "Static секретный ключ, идентифицирующий приложение (НЕ пользователя). Часто в header (<code>X-API-Key</code>) или query param",
    "istqb": "CTFL-Ch4",
    "introducedIn": "S09"
  },
  {
    "id": "atelier-api",
    "termRu": "Atelier · API scenario",
    "termEn": "Atelier API",
    "short": "QA Studio's interactive API sandbox с deterministic mock backend (real HTTP semantics). Block 2 fixtures для S09 Mission",
    "istqb": "CTFL-Ch4",
    "introducedIn": "S09"
  },
  {
    "id": "authorization-http-header",
    "termRu": "заголовок авторизации",
    "termEn": "Authorization (HTTP header)",
    "short": "HTTP-заголовок для передачи credentials. Форматы: Bearer (token) · Basic (login:pass base64) · API key",
    "istqb": "CTFL-Ch4",
    "introducedIn": "S09"
  },
  {
    "id": "basic-auth",
    "termRu": "базовая авторизация · RFC 7617",
    "termEn": "Basic auth",
    "short": "login:password в base64 в Authorization header. НЕ secure без HTTPS. Legacy. Server-to-server / admin tools",
    "istqb": "CTFL-Ch4",
    "introducedIn": "S09"
  },
  {
    "id": "bearer-token",
    "termRu": "Bearer-токен",
    "termEn": "Bearer token",
    "short": "Самый частый authentication method. Token (часто JWT) в Authorization header: `Bearer eyJ...`. OAuth result · современные REST APIs",
    "istqb": "CTFL-Ch4",
    "introducedIn": "S09"
  },
  {
    "id": "client-server-model",
    "termRu": "клиент-серверная модель",
    "termEn": "client-server model",
    "short": "Архитектура: client (browser · mobile app · Postman) посылает requests · server (API) обрабатывает и возвращает responses",
    "istqb": "CTFL-Ch4",
    "introducedIn": "S09"
  },
  {
    "id": "collection-postman-api-tool",
    "termRu": "коллекция запросов",
    "termEn": "collection (Postman / API tool)",
    "short": "Группа saved requests, organized по фиче / API. Reusable across team",
    "istqb": "CTFL-Ch4",
    "introducedIn": "S09"
  },
  {
    "id": "cors-cross-origin-resource-sharing",
    "termRu": "CORS",
    "termEn": "CORS (Cross-Origin Resource Sharing)",
    "short": "Browser security policy: блокирует requests от одного домена к другому без backend permission через Access-Control-* headers",
    "istqb": "CTFL-Ch4",
    "introducedIn": "S09"
  },
  {
    "id": "curl-reproduction",
    "termRu": "воспроизведение через curl",
    "termEn": "curl reproduction",
    "short": "Command-line representation HTTP запроса. Single-command paste для backend Dev из bug report",
    "istqb": "CTFL-Ch4",
    "introducedIn": "S09"
  },
  {
    "id": "endpoint",
    "termRu": "эндпоинт API",
    "termEn": "endpoint",
    "short": "Конкретный URL + method, представляющий API operation. Например, `POST /api/orders` — endpoint для создания заказа",
    "istqb": "CTFL-Ch4",
    "introducedIn": "S09"
  },
  {
    "id": "environment-postman",
    "termRu": "окружение Postman",
    "termEn": "environment (Postman)",
    "short": "Набор variables для разных стендов (dev / staging / prod). Переключается одной кнопкой",
    "istqb": "CTFL-Ch4",
    "introducedIn": "S09"
  },
  {
    "id": "http-hypertext-transfer-protocol",
    "termRu": "HTTP-протокол",
    "termEn": "HTTP (Hypertext Transfer Protocol)",
    "short": "Stateless protocol передачи данных в web. Каждый запрос независим. Версии: HTTP/1.1 / HTTP/2 / HTTP/3",
    "istqb": "CTFL-Ch4",
    "introducedIn": "S09"
  },
  {
    "id": "http-method",
    "termRu": "HTTP-метод",
    "termEn": "HTTP method",
    "short": "Декларирует, что клиент хочет сделать с ресурсом. 5 главных: GET · POST · PUT · PATCH · DELETE",
    "istqb": "CTFL-Ch4",
    "introducedIn": "S09"
  },
  {
    "id": "idempotency",
    "termRu": "идемпотентность",
    "termEn": "idempotency",
    "short": "Свойство операции: повторный вызов с теми же параметрами не меняет результат. Idempotent: GET · PUT · DELETE. NOT idempotent: POST · PATCH",
    "istqb": "CTFL-Ch4",
    "introducedIn": "S09"
  },
  {
    "id": "insomnia-bruno",
    "termRu": "Insomnia / Bruno · API tools secondary",
    "termEn": "Insomnia / Bruno",
    "short": "Modern lightweight alternatives к Postman. Insomnia — Kong-acquired · Bruno — open source · Git-native",
    "istqb": "CTFL-Ch4",
    "introducedIn": "S09"
  },
  {
    "id": "oauth-authorization-code-with-pkce",
    "termRu": "OAuth 2.0 Authorization Code flow с PKCE",
    "termEn": "OAuth Authorization Code with PKCE",
    "short": "Современный flow для third-party authorization. PKCE (Proof Key for Code Exchange · RFC 7636) защищает от code interception",
    "istqb": "CTFL-Ch4",
    "introducedIn": "S09"
  },
  {
    "id": "postman",
    "termRu": "Postman · postman.com",
    "termEn": "Postman",
    "short": "Industry-standard API testing tool. ~60% market share. Free tier для small teams. Collections · environments · scripts · documentation",
    "istqb": "CTFL-Ch4",
    "introducedIn": "S09"
  },
  {
    "id": "request-http",
    "termRu": "запрос",
    "termEn": "request (HTTP)",
    "short": "Сообщение от client'а к server'у. 4 части: method · URL · headers · body",
    "istqb": "CTFL-Ch4",
    "introducedIn": "S09"
  },
  {
    "id": "response-http",
    "termRu": "ответ",
    "termEn": "response (HTTP)",
    "short": "Сообщение от server'а к client'у. 3 части: status code · headers · body",
    "istqb": "CTFL-Ch4",
    "introducedIn": "S09"
  },
  {
    "id": "soapui",
    "termRu": "SoapUI · ReadyAPI",
    "termEn": "SoapUI",
    "short": "Enterprise API tool. Поддерживает REST + SOAP + advanced testing features. Java-based. Banking / fintech / regulated industries",
    "istqb": "CTFL-Ch4",
    "introducedIn": "S09"
  },
  {
    "id": "status-code-http",
    "termRu": "код состояния HTTP",
    "termEn": "status code (HTTP)",
    "short": "3-цифровой результат каждого HTTP-запроса. 5 категорий (1xx-5xx). 4xx — client error · 5xx — server error",
    "istqb": "CTFL-Ch4",
    "introducedIn": "S09"
  },
  {
    "id": "trace-id-x-request-id",
    "termRu": "trace ID для distributed tracing",
    "termEn": "trace ID / X-Request-Id",
    "short": "Unique correlation ID, проходящий через все services в distributed system. Позволяет backend Dev найти full path в observability tools (Datadog · Jaeger · Honeycomb)",
    "istqb": "CTFL-Ch4",
    "introducedIn": "S09"
  },
  {
    "id": "variable-postman",
    "termRu": "переменная в API tool",
    "termEn": "variable (Postman)",
    "short": "Reusable value (baseUrl · authToken · userId), на которую ссылаются requests через `{{name}}` syntax",
    "istqb": "CTFL-Ch4",
    "introducedIn": "S09"
  },
  {
    "id": "accessibility-testing",
    "termRu": "тестирование доступности",
    "termEn": "Accessibility testing (a11y)",
    "short": "Проверка, что продуктом могут пользоваться люди с нарушениями зрения, слуха, моторики, когнитивными особенностями. Сокращённо a11y. Стандарт-ориентир — WCAG. Подвид non-functional",
    "istqb": "CTFL-Ch2",
    "klevel": "K2",
    "introducedIn": "S12"
  },
  {
    "id": "wcag",
    "termRu": "WCAG · руководство по доступности веб-контента",
    "termEn": "WCAG 2.1 AA",
    "short": "Web Content Accessibility Guidelines — международный стандарт доступности. 4 принципа POUR (Perceivable · Operable · Understandable · Robust). Уровень AA — рыночный минимум для большинства продуктов",
    "klevel": "K1",
    "introducedIn": "S12"
  },
  {
    "id": "owasp-top-10",
    "termRu": "OWASP Top 10",
    "termEn": "OWASP Top 10",
    "short": "Регулярно обновляемый список 10 самых критичных угроз безопасности web-приложений от OWASP. Стартовый чек-лист security-рисков для QA. A01 (актуальная редакция) — Broken Access Control",
    "klevel": "K1",
    "introducedIn": "S12"
  },
  {
    "id": "broken-access-control",
    "termRu": "нарушение контроля доступа",
    "termEn": "Broken Access Control (A01)",
    "short": "Категория A01 в OWASP Top 10: пользователь получает доступ к данным или действиям сверх своих прав. Включает IDOR/BOLA, обход проверок роли, доступ к чужим ресурсам по прямой ссылке",
    "klevel": "K1",
    "introducedIn": "S12"
  },
  {
    "id": "idor",
    "termRu": "небезопасная прямая ссылка на объект",
    "termEn": "IDOR / BOLA",
    "short": "Insecure Direct Object Reference (он же Broken Object Level Authorization): меняешь id в запросе (`/orders/123` → `/orders/124`) и видишь чужой объект, потому что сервер не проверил права. Частный случай Broken Access Control",
    "klevel": "K1",
    "introducedIn": "S12"
  },
  {
    "id": "authentication-vs-authorization",
    "termRu": "аутентификация vs авторизация",
    "termEn": "Authentication vs Authorization",
    "short": "Authentication (authn) — «кто ты» (проверка личности: логин, токен). Authorization (authz) — «что тебе можно» (проверка прав на ресурс/действие). Большинство access-control багов — на стороне authz",
    "klevel": "K2",
    "introducedIn": "S12"
  },
  {
    "id": "core-web-vitals",
    "termRu": "ключевые веб-метрики",
    "termEn": "Core Web Vitals (LCP / INP / CLS)",
    "short": "Набор пользователе-центричных метрик производительности от Google: LCP (скорость загрузки основного контента) · INP (отзывчивость на взаимодействие) · CLS (визуальная стабильность вёрстки). Влияют на UX и SEO",
    "klevel": "K1",
    "introducedIn": "S12"
  },
  {
    "id": "lighthouse",
    "termRu": "Lighthouse · аудит в DevTools",
    "termEn": "Lighthouse",
    "short": "Бесплатный инструмент аудита от Google (встроен в Chrome DevTools). Оценивает Performance, Accessibility, Best Practices, SEO одним прогоном и выдаёт actionable-отчёт с метриками Core Web Vitals",
    "klevel": "K1",
    "introducedIn": "S12"
  },
  {
    "id": "axe-devtools",
    "termRu": "axe DevTools · сканер доступности",
    "termEn": "axe DevTools",
    "short": "Индустриальный автоматический сканер доступности (Deque). Находит часть нарушений WCAG в браузере. Покрывает ~30-40% проблем — остальное требует ручной проверки (клавиатура, скринридер)",
    "klevel": "K1",
    "introducedIn": "S12"
  },
  {
    "id": "master-test-strategy",
    "termRu": "мастер-стратегия тестирования",
    "termEn": "Master Test Strategy",
    "short": "Зонтичный документ, описывающий подход к тестированию для всего продукта/программы поверх уровней и типов (functional + NF). Связывает частные test plan'ы под общие принципы. Расширяет понятие test strategy на масштаб всего проекта",
    "istqb": "CTFL-Ch5",
    "klevel": "K2",
    "introducedIn": "S12",
    "related": ["test-strategy", "test-plan"]
  }
];
